// @flow

export function peruvianDocumentTypeInferredFromValue(document: ?string): string {
  return !document || document.length < 11 ? 'DNI' : 'RUC';
}

export function hasPeruvianRucDocumentTypeSupport(paymentMethod: string): boolean {
  const paymentMethodSupported = ['banktransfer'];
  return paymentMethodSupported.includes(paymentMethod);
}
